{
  "user": {
    "dashboard": {
      "placeholder": "Hi this is the dashboard"
    }
  },
  "manager": {
    "dashboardIndex": {
      "welcomeBack": "Welcome back, {name}",
      "subtitle": "Here's what's happening with your community today",
      "todaysDate": "Today's date is {date}",
      "statActiveMembers": "Active Members",
      "vsLastMonth": "vs last month",
      "statNewThisWeek": "New This Week",
      "vsLastWeek": "vs last week",
      "statRevenueToday": "Revenue Today",
      "vsYesterday": "vs yesterday",
      "statProgramsActive": "Programs Active",
      "locked": "Locked",
      "statTotalRevenue": "Total Revenue",
      "thisMonth": "this month"
    }
  }
}
